import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import LicenceActionDetails from "./LicenceActionDetails";
import LicenceActionHeader from "./LicenceActionHeader";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import FurtherInformation from "./FurtherInformation";
import Page500 from "../../../pages/auth/Page500";
import {
  loadLicenceActionAsync,
  selectLicenceAction,
} from "../../../redux/slices/licenceAction";

const LicenceAction = () => {
  const [loading, setLoading] = useState(false);
  const [loadingLicenceActionId, setLoadingLiceneActionId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const licenceActionSelector = useAppSelector(selectLicenceAction);

  const dispatch = useAppDispatch();

  let { profileNo, licenceActionId } = useParams();
  if (!profileNo || !licenceActionId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingLicenceActionId !== licenceActionId) {
    setLoadingLiceneActionId(licenceActionId);
    dispatch(loadLicenceActionAsync(licenceActionId));
    return <Loading />;
  }

  const licenceActionDetails = licenceActionSelector.licenceAction;

  if (!licenceActionDetails) {
    return <Loading />;
  }

  if (!licenceActionDetails.response.ok) {
    if (licenceActionDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceActionHeader licenceActionDetails={licenceActionDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LicenceActionDetails licenceActionDetails={licenceActionDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <FurtherInformation
            licenceActionDetails={licenceActionDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        licenceActionDetails={licenceActionDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="licence-versions"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default LicenceAction;
